var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c(_setup.SimulationFormStep3,{attrs:{"income":_vm.borrower.mainIncome}}),_vm._v(" "),(_vm.borrower.hasAdditionalIncomeSource)?_c(_setup.SimulationFormStep3,{attrs:{"income":_vm.borrower.additionalIncome,"income-number":2}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }